<h1 class="mt-3">Weather data</h1>

<p class="my-3">
  This site displays weather information.
  You can add new locations and daily weather data for the selected location.
  In addition, you can specify a date range to filter information.
</p>

<div class="form-row">
  <label class="col-form-label" for="locationSel">Location:</label>
  <div class="form-group col-md-3">
    <select class="custom-select form-control"
      id="locationSel"
      [(ngModel)]="locationSelModel"
      (ngModelChange)="onLocationChange($event)"
      title="Select location">
      <option *ngFor="let location of locations" [ngValue]="location">{{ location.name }}</option>
    </select>
  </div>
  <div class="form-group col-md-4">
    <button class="btn btn-primary btn-fixed-width"
      data-toggle="modal"
      data-target="#addLocationModal"
      title="Add new location"
      type="button">
      Add
    </button>
    <button class="btn btn-danger btn-fixed-width ml-2"
      (click)="delLocation()"
      data-toggle="modal"
      data-target="#delLocationModal"
      [disabled]="noLocations"
      title="Delete selected location"
      type="button">
      Delete
    </button>
  </div>
  <div class="ml-auto mr-1">
    <button class="btn btn-primary btn-fixed-width"
      (click)="addWeatherData()"
      data-toggle="modal"
      data-target="#addEditWeatherDataModal"
      [disabled]="noLocations"
      title="Add weather data"
      type="button">
      Add data
    </button>
  </div>
</div>

<div class="form-row mt-1">
  <div class="form-group col-md-3 offset-md-3">
    <label for="startDate">Start date:</label>
    <input (change)="onStartDateChange($event.target.value)"
      class="form-control"
      [disabled]="noLocations"
      id="startDate"
      [(ngModel)]="startDateModel"
      title="Enter start date"
      type="date">
  </div>
  <div class="form-group col-md-3">
    <label for="endDate">End date:</label>
    <input (change)="onEndDateChange($event.target.value)"
      class="form-control"
      [disabled]="noLocations"
      id="endDate"
      [(ngModel)]="endDateModel"
      title="Enter end date"
      type="date">
  </div>
</div>

<div aria-hidden="true"
  aria-labelledby="addLocationModalLbl"
  class="modal fade"
  id="addLocationModal"
  role="dialog"
  tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addLocationModalLbl">Add new location</h5>
        <button aria-label="Close"
          class="close"
          data-dismiss="modal"
          type="button"
          #closeAddLocationBtn>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #locationForm="ngForm" (ngSubmit)="onSubmitLocation(locationForm)">
        <div class="modal-body">
          <div class="form-group">
            <label class="col-form-label" for="locationTxt">Location:</label>
            <input class="form-control"
              id="locationTxt"
              maxlength="100"
              [ngClass]="{'is-invalid': locationTxt.touched && locationTxt.invalid}"
              [(ngModel)]="locationTxtModel"
              name="locationTxt"
              #locationTxt="ngModel"
              placeholder="Example: Sodankylä"
              required
              title="Enter location"
              type="text">
            <div class="invalid-feedback" *ngIf="locationTxt.touched && locationTxt.invalid">
              <div *ngIf="locationTxt.errors.required">
                Location is required.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary btn-modal-width"
            data-dismiss="modal"
            title="Close dialog"
            type="button">
            Close
          </button>
          <button class="btn btn-primary btn-modal-width"
            [disabled]="!locationForm.valid"
            title="Save location"
            type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div aria-hidden="true"
  aria-labelledby="delLocationModalLbl"
  class="modal fade"
  id="delLocationModal"
  role="dialog"
  tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="delLocationModalLbl">Delete {{ tempName }}</h5>
        <button aria-label="Close"
          class="close"
          data-dismiss="modal"
          type="button"
          #closeDelLocationBtn>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this location?
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary btn-modal-width"
          data-dismiss="modal"
          title="Close dialog"
          type="button">
          Close
        </button>
        <button class="btn btn-danger btn-modal-width"
          (click)="onDeleteLocation()"
          title="Delete location"
          type="button">
          Delete
        </button>
      </div>
    </div>
  </div>
</div>

<div aria-hidden="true"
  aria-labelledby="addEditWeatherDataModalLbl"
  class="modal fade"
  id="addEditWeatherDataModal"
  role="dialog"
  tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addEditWeatherDataModalLbl">
          {{ action }} weather data for {{ locationSelModel.name }}
        </h5>
        <button aria-label="Close"
          class="close"
          data-dismiss="modal"
          type="button"
          #closeAddEditWeatherDataBtn>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="weatherDataForm" (ngSubmit)="onSubmitWeatherData()">
        <div class="modal-body">
          <div class="form-group">
            <label class="col-form-label" for="dateDate">Date:</label>
            <input class="form-control"
              formControlName="dateDate"
              id="dateDate"
              [ngClass]="{'is-invalid': weatherDataForm.controls.dateDate.touched &&
                weatherDataForm.controls.dateDate.invalid}"
              required
              title="Enter date"
              type="date">
            <div class="invalid-feedback"
              *ngIf="weatherDataForm.controls.dateDate.touched &&
                weatherDataForm.controls.dateDate.invalid">
              <div *ngIf="weatherDataForm.controls.dateDate.errors.required">
                Date is required.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="temperatureNo">Temperature (&#8451;):</label>
            <input class="form-control"
              formControlName="temperatureNo"
              id="temperatureNo"
              min="-150"
              max="150"
              [ngClass]="{'is-invalid': weatherDataForm.controls.temperatureNo.touched &&
                weatherDataForm.controls.temperatureNo.invalid}"
              placeholder="Example: 10"
              required
              title="Enter temperature"
              type="number">
            <div class="invalid-feedback"
              *ngIf="weatherDataForm.controls.temperatureNo.touched &&
                weatherDataForm.controls.temperatureNo.invalid">
              <div *ngIf="weatherDataForm.controls.temperatureNo.errors.required">
                Temperature is required.
              </div>
              <div *ngIf="weatherDataForm.controls.temperatureNo.errors.min">
                Minimum value is -150.
              </div>
              <div *ngIf="weatherDataForm.controls.temperatureNo.errors.max">
                Maximum value is 150.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="rainfallNo">Rainfall (mm):</label>
            <input class="form-control"
              formControlName="rainfallNo"
              id="rainfallNo"
              min="0"
              max="2500"
              [ngClass]="{'is-invalid': weatherDataForm.controls.rainfallNo.touched &&
                weatherDataForm.controls.rainfallNo.invalid}"
              placeholder="Example: 2"
              required
              title="Enter rainfall"
              type="number">
            <div class="invalid-feedback"
              *ngIf="weatherDataForm.controls.rainfallNo.touched &&
                weatherDataForm.controls.rainfallNo.invalid">
              <div *ngIf="weatherDataForm.controls.rainfallNo.errors.required">
                Rainfall is required.
              </div>
              <div *ngIf="weatherDataForm.controls.rainfallNo.errors.min">
                Minimum value is 0.
              </div>
              <div *ngIf="weatherDataForm.controls.rainfallNo.errors.max">
                Maximum value is 2500.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="windNo">Wind (m/s):</label>
            <input class="form-control"
              formControlName="windNo"
              id="windNo"
              min="0"
              max="450000"
              [ngClass]="{'is-invalid': weatherDataForm.controls.windNo.touched &&
                weatherDataForm.controls.windNo.invalid}"
              placeholder="Example: 5"
              required
              title="Enter wind"
              type="number">
            <div class="invalid-feedback"
              *ngIf="weatherDataForm.controls.windNo.touched &&
                weatherDataForm.controls.windNo.invalid">
              <div *ngIf="weatherDataForm.controls.windNo.errors.required">
                Wind is required.
              </div>
              <div *ngIf="weatherDataForm.controls.windNo.errors.min">
                Minimum value is 0.
              </div>
              <div *ngIf="weatherDataForm.controls.windNo.errors.max">
                Maximum value is 450000.
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-form-label" for="windDirectionSel">Wind direction:</label>
            <select class="custom-select form-control"
              formControlName="windDirectionSel"
              id="windDirectionSel"
              title="Select wind direction">
              <option *ngFor="let direction of windDirections">{{ direction }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary btn-modal-width"
            data-dismiss="modal"
            title="Close dialog"
            type="button">
            Close
          </button>
          <button class="btn btn-primary btn-modal-width"
            [disabled]="!weatherDataForm.valid"
            title="Save data"
            type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div aria-hidden="true"
  aria-labelledby="delWeatherDataModalLbl"
  class="modal fade"
  id="delWeatherDataModal"
  role="dialog"
  tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="delWeatherDataModalLbl">
          Delete weather data for {{ delDate }}
        </h5>
        <button aria-label="Close"
          class="close"
          data-dismiss="modal"
          type="button"
          #closeDelWeatherDataBtn>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this data?
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary btn-modal-width"
          data-dismiss="modal"
          title="Close dialog"
          type="button">
          Close
        </button>
        <button class="btn btn-danger btn-modal-width"
          (click)="onDeleteWeatherData()"
          title="Delete data"
          type="button">
          Delete
        </button>
      </div>
    </div>
  </div>
</div>

<app-meteogram></app-meteogram>

<div class="table-wrapper mt-2">
  <table class="table table-sm table-striped text-center">
    <thead class="thead-dark">
      <tr>
        <th class="align-middle">Date</th>
        <th class="align-middle">Temp. (&#8451;)</th>
        <th class="align-middle">Rainfall (mm)</th>
        <th class="align-middle">Wind (m/s)</th>
        <th class="align-middle">Wind dir.</th>
        <th class="align-middle">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of tableWeatherDataItems | keyvalue: returnZero">
        <td class="align-middle">{{ item.key | date: 'd.M.yyyy' }}</td>
        <td class="align-middle">{{ item.value.temperature }}</td>
        <td class="align-middle">{{ item.value.rainfall }}</td>
        <td class="align-middle">{{ item.value.wind }}</td>
        <td class="align-middle">{{ item.value.windDirection }}</td>
        <td class="align-middle">
          <button class="btn btn-success ml-2 my-1"
            (click)="editWeatherData(item)"
            data-toggle="modal"
            data-target="#addEditWeatherDataModal"
            title="Edit data"
            type="button">
            <svg class="bi bi-pencil-square"
              fill="currentColor"
              height="1em"
              width="1em"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456l-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
              <path fill-rule="evenodd"
                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
            </svg>
          </button>
          <button class="btn btn-danger ml-2 my-1"
            (click)="delWeatherData(item)"
            data-toggle="modal"
            data-target="#delWeatherDataModal"
            title="Delete data"
            type="button">
            <svg class="bi bi-trash"
              fill="currentColor"
              height="1em"
              width="1em"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
              <path fill-rule="evenodd"
                d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
            </svg>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
